import { Badge } from "@arcadeai/design-system/components/ui/atoms/badge";
import { useSidebar } from "@arcadeai/design-system/components/ui/atoms/sidebar";
import { cn } from "@arcadeai/design-system/lib/utils";
import type { SidebarItem } from "../types";

type UseBadgeOptions = {
  item: SidebarItem;
  isSubItem?: boolean;
  isActive?: boolean;
};

export const useBadge = ({
  item,
  isSubItem = false,
  isActive = false,
}: UseBadgeOptions) => {
  const { state } = useSidebar();
  const badgeData = item.useBadgeCount?.();
  const showBadge = badgeData && !badgeData.isLoading && badgeData.count > 0;

  if (!showBadge) {
    return null;
  }

  return state === "expanded" ? (
    <Badge
      className={cn(
        "ml-auto shrink-0",
        isSubItem && "text-xs",
        isActive && "bg-white text-black"
      )}
      variant={isActive ? "secondary" : "warning"}
    >
      {badgeData.count}
    </Badge>
  ) : (
    <span
      className={cn(
        "absolute top-1 right-1 size-2 rounded-full",
        isActive ? "bg-white" : "bg-warning"
      )}
    />
  );
};
